import React from "react";

export default () => {
    return <i className="sprite sprite-dropdown-arrow"></i>;
};
